import { Chip, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DATE_FORMATS } from '@callmart/types';
import getFrequencyLabel from './utils/getFrequencyLabel';
import { getOrdinalNumberLabel } from './utils/serieDialogUtils';
import dayjs from '@utils/dayjs';

const EventRecurringInfo = ({ eventSerie }) => {
    const { t } = useTranslation('allDeltas');
    const { frequency, repetitionIntervalDayOrdinalNumber, repetitionIntervalDayNumber, repetitionIntervalType } =
        eventSerie;
    let { start, end, weekDaysRepetition, repetitionIntervalDayOfWeek, repetition } = eventSerie;

    start = start && dayjs(start).format(DATE_FORMATS.DATE);
    end = end && dayjs(end).format(DATE_FORMATS.DATE);
    weekDaysRepetition =
        weekDaysRepetition &&
        Array.isArray(weekDaysRepetition) &&
        weekDaysRepetition
            .sort()
            .map((day) => dayjs().day(day).format(DATE_FORMATS.WEEKDAY_SHORT))
            .join(', ');

    repetitionIntervalDayOfWeek =
        repetitionIntervalDayOfWeek && dayjs().day(repetitionIntervalDayOfWeek).format(DATE_FORMATS.WEEKDAY_SHORT);
    if (frequency === 'year')
        repetition =
            repetition &&
            dayjs()
                .month(repetition - 1)
                .format(DATE_FORMATS.MONTH_NAME);

    return (
        <Grid container spacing={1} sx={{ mt: 1, ml: 2 }}>
            <Grid item>
                <Chip color="primary" size="small" variant="outlined" label={t('serie.fromTo', { start, end })} />
            </Grid>

            {frequency !== 'year' && repetition > 1 && (
                <Grid item>
                    <Chip
                        color="primary"
                        size="small"
                        variant="outlined"
                        label={t('serie.everyN', { count: repetition })}
                    />
                </Grid>
            )}

            <Grid item>
                <Chip
                    color="primary"
                    size="small"
                    variant="outlined"
                    label={getFrequencyLabel(frequency, repetition, t)}
                />
            </Grid>

            {frequency === 'week' && (
                <Grid item>
                    <Chip color="primary" size="small" variant="outlined" label={weekDaysRepetition} />
                </Grid>
            )}

            {frequency === 'year' && (
                <Grid item>
                    <Chip color="primary" size="small" variant="outlined" label={repetition} />
                </Grid>
            )}

            {frequency !== 'week' && repetitionIntervalType === 'DAY_NUMBER_REPETITION' && (
                <Grid item>
                    <Chip
                        color="primary"
                        size="small"
                        variant="outlined"
                        label={t('serie.onDayNumber', { day: repetitionIntervalDayNumber })}
                    />
                </Grid>
            )}
            {frequency !== 'week' && repetitionIntervalType === 'DAY_ORDINAL_NUMBER_REPETITION' && (
                <Grid item>
                    <Chip
                        color="primary"
                        size="small"
                        variant="outlined"
                        label={t('serie.onOrdinalDay', {
                            ordinal: getOrdinalNumberLabel(repetitionIntervalDayOrdinalNumber, t).toLowerCase(),
                            weekday: repetitionIntervalDayOfWeek,
                        })}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default EventRecurringInfo;
